export default __webpack_public_path__ + "static/media/first-position.d8f39d9e.svg";